import Account from '@/models/Account'
import axios from 'axios'
import Api from '@/api'
import { each, find, findIndex } from 'lodash'

export default {
  namespaced: true,
  state: {
    customAccount: null,
    list: []
  },

  getters: {
    customAccountStatus(state) {
      if (
        state.customAccount &&
        (state.customAccount.payouts_enabled ||
          (state.customAccount.requirements.pending_verification.length === 0 &&
            state.customAccount.requirements.eventually_due.length === 1 &&
            state.customAccount.requirements.eventually_due[0] ===
              'external_account'))
      ) {
        return true
      } else {
        return false
      }
    },

    externalAccountForm: (state, getters) => params => {
      let formData = []
      const details = {
        country: 'AU',
        currency: 'aud',
        account_holder_name: params.account_name,
        account_holder_type: 'individual',
        routing_number: params.account_bsb,
        account_number: params.account_number
      }

      for (let property in details) {
        let encodedKey = encodeURIComponent(property)
        let encodedValue = encodeURIComponent(details[property])
        formData.push('bank_account[' + encodedKey + ']=' + encodedValue)
      }

      return formData.join('&')
    }
  },

  mutations: {
    setCustomAccount(state, customAccount) {
      state.customAccount = customAccount
    },

    clearExternalAccounts(state) {
      state.list = []
    },

    setAccountList(state, accounts) {
      each(accounts, account => {
        const exist = find(state.list, { id: account.id })
        if (!exist) {
          state.list.push(new Account(account))
        }
      })
    },

    clearAccountListItemDetails(state, id) {
      const index = findIndex(state.list, { id: id })
      state.list.splice(index, 1)
    },

    setAccountListItemDefault(state, id) {
      const current = findIndex(state.list, { default_for_currency: true })
      if (current > -1) {
        state.list[current].default_for_currency = false
      }

      const index = findIndex(state.list, { id: id })
      if (index > -1) {
        state.list[index].default_for_currency = true
      }
    }
  },

  actions: {
    async getCustomAccount({ commit }, params) {
      const { data } = await Api.get(`auth/connect/account`)

      commit('setCustomAccount', data.data)
      commit('setAccountList', data.data.external_accounts.data)
    },

    async getCustomAccountLink({ commit }, formData) {
      return Api.post(`auth/connect/account-links`, formData)
    },

    async createCustomAccount({ commit }) {
      const { data } = await Api.post(`auth/connect/account`)
      commit('setCustomAccount', data.data)
    },

    async getExternalAccounts({ commit }, params) {
      const { data } = await Api.get(`auth/connect/external-accounts`)
      commit('setAccountList', data.data)
    },

    async createExternalAccount({ commit, getters }, params) {
      return axios.post(
        'https://api.stripe.com/v1/tokens',
        getters.externalAccountForm(params),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${this._vm.$env.stripePublishableKey}`
          }
        }
      )
    },

    async saveExternalAccount({ commit, state }, formData) {
      const { data } = await Api.post(
        `auth/connect/external-accounts`,
        formData
      )
      state.list.unshift(new Account(data.data))
    },

    async deleteExternalAccount({ commit, state }, id) {
      await Api.delete(`auth/connect/external-accounts/${id}`)
      commit('clearAccountListItemDetails', id)
    },

    async setExternalAccountAsPrimary({ commit, state }, id) {
      await Api.put(`auth/connect/external-accounts/${id}`, {
        default_for_currency: true
      })
      commit('setAccountListItemDefault', id)
    }
  }
}
